// src/components/bucket/CategoryFilterMenu.jsx
import React from "react";
import {
  WrapItem,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Checkbox,
  IconButton,
  Box,
  Text,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FaFilter } from "react-icons/fa";
import Translate from "../../components/LanguageTranslation/Translate";

const CategoryFilterMenu = ({
  tag, // e.g. "explore" or "transportation"
  label, // button or icon label
  isActive, // whether any selections are active
  options, // array of { label, pref }
  selections, // current selected prefs
  toggleSelection, // handler(pref)
  useIcon = false, // show icon instead of text button
}) => (
  <WrapItem key={tag}>
    <Menu
      closeOnSelect={false}
      // Prevent auto-scrolling behavior when menu opens
      autoSelect={false} // Chakra v2+ only
      isLazy // Optional: speeds up performance, delays rendering until open
    >
      {/* Button or Icon */}
      {!useIcon ? (
        <MenuButton
          as={Button}
          bg={isActive ? "#286328" : "blackAlpha.100"}
          color={isActive ? "white" : "black"}
          _hover="none"
          borderRadius="lg"
          rightIcon={<ChevronDownIcon />}
        >
          <Translate text={label} />
        </MenuButton>
      ) : (
        <MenuButton
          as={IconButton}
          aria-label={`Filter ${label}`}
          icon={<ChevronDownIcon boxSize={5} />}
          variant="ghost"
          _hover="none"
          size="sm"
        />
      )}

      <MenuList maxH="300px" overflowY="auto">
        {options.map(({ label: optLabel, pref }) => {
          const checked = selections.includes(pref);
          return (
            <MenuItem
              key={pref}
              onClick={() => toggleSelection(pref)}
              _hover={{
                bg: "blackAlpha.100",
              }}
              bg="transparent"
              closeOnSelect={false}
            >
              <Checkbox
                isChecked={checked}
                pointerEvents="none"
                mr={2}
              />
              <Box as="span" display="inline-flex" alignItems="center">
                <Translate text={optLabel} />
              </Box>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  </WrapItem>
);

export default CategoryFilterMenu;
